export enum ErrorTypes {
  default = 'default',
  notFound = 'notFound',
  productNotFound = 'productNotFound',
  emptyProductsList = 'emptyProductsList',
}
